import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      marginHorizontal: 24,
      marginVertical: 24,
    },
    rowContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 8,
      // Keep label and value apart at large accessibility font sizes.
      gap: 16,
    },
    rowLabel: {
      flexShrink: 0,
    },
    rowValue: {
      // Let long amounts wrap under system font scaling instead of
      // colliding with the label.
      flex: 1,
      textAlign: 'right',
    },
    priceDetailContainer: {
      backgroundColor: colors.surface,
      borderRadius: 16,
      paddingHorizontal: 12,
      paddingVertical: 16,
      shadowColor: colors.shadow,
      shadowOpacity: 0.12,
      shadowRadius: 30,
      shadowOffset: {width: 0, height: 30},
      elevation: 30,
    },
    marginVertical16: {
      marginVertical: 16,
    },
    totalContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      // Keep label and value apart at large accessibility font sizes.
      gap: 16,
    },
    mb16: {
      marginBottom: 16,
    },
    ls2: {
      letterSpacing: 2,
    },
  });

export default makeStyles;
